export default "__VITE_ASSET__yU2bh2tS__"